import { MessageCircle } from "lucide-react";
import { waHref } from "@/lib/wa";

export default function WhatsAppFloat({ content }) {
  const href = waHref(content);
  return (
    <a
      href={href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel="noopener"
      aria-label="Chat Marketing via WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-5 right-5 z-[60] flex items-center gap-2.5 rounded-full bg-[#25D366] py-3.5 pl-4 pr-5 text-white shadow-[0_12px_32px_rgb(37,211,102,0.4)] transition-transform duration-200 hover:scale-105 active:scale-95"
    >
      <span className="absolute inset-0 -z-10 animate-pulse-ring rounded-full bg-[#25D366]" aria-hidden="true" />
      <MessageCircle className="h-6 w-6" />
      <span className="text-sm font-bold">Chat Marketing</span>
    </a>
  );
}
